<input (keyup)="keyUp($event)" class="form-control" [(ngModel)]="searchString" [disabled]="disabled"/>
<select id={{aid}} class="form-control" [(ngModel)]="value" multiple="multiple" size="{{size}}" [disabled]="disabled">
  @for (item of filteredItems; track item) {
    <option (click)="select()" [value]="item" >{{formatter(item)}}</option>
  }
</select>
